import * as React from 'react';
import { IIPLDataSaveConnectProps } from './ipl-data-save-container';
import { DataSaveContainer } from '../../data-save';
import { DataLoadApi } from '../../../api';
import { IIPLConfig } from '../../../interfaces';
import { DATA_LOAD_TYPE } from '../../../constants';
import { getApiIPLConfig } from '../../../functions';

/**
 * Wrapper around "Data Save" component for Indicator-Process Links
 */
export class IPLDataSave extends React.Component<IIPLDataSaveConnectProps> {
  constructor(props: IIPLDataSaveConnectProps) {
    super(props);
    this.onRetry = this.onRetry.bind(this);
  }

  public onRetry(): Promise<{}> {
    const config: IIPLConfig = getApiIPLConfig({
      config: this.props.config.IPL,
      ui: this.props.ui,
      upload: this.props.upload
    });

    return DataLoadApi.uploadIPLConfig({ config, columns: this.props.config.columns }).request();
  }

  public render(): JSX.Element {
    if (!this.props.config.IPL) { return null; }

    const nRows: number = this.props.config.IPL.tableConfig.dataEndRow
      - this.props.config.IPL.tableConfig.dataStartRow;

    return (
      <DataSaveContainer
        nRows={nRows}
        dataLoadType={DATA_LOAD_TYPE.INDICATOR_PROCESS_LINK}
        onRetry={this.onRetry}
      />
    );
  }
}
